import cloneDeep from 'lodash/cloneDeep';
import gestionDateBase from '@/services/general/gestionDateBase';

export default function formateCommandeAchatBailleurForFront(commandeToFormate) {
  const commande = cloneDeep(commandeToFormate);
  commande.dateDevisCommande = gestionDateBase(commande.dateDevisCommande);
  commande.lignesCommande.forEach(ligne => {
    ligne.dateDebut = gestionDateBase(ligne.dateDebut);
    ligne.dateFin = gestionDateBase(ligne.dateFin);
  });
  return commande;
}
